import { render, staticRenderFns } from "./recipe-version-modal.vue?vue&type=template&id=0b4ff43a"
import script from "./recipe-version-modal.vue?vue&type=script&lang=js"
export * from "./recipe-version-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports